import React from 'react'
import '../../assets/css/Thankyou.css'
import { completePageTitle } from '../../utils/ConsultationAppText'
import HTMLFragment from '../HTMLFragment'

const ConsultationComplete = () => {
    document.title = completePageTitle
    return (
        <HTMLFragment componentPath={'/forms/html/CompleteBody.htm'} />
    )
}

export default ConsultationComplete
